import { useEffect, useRef } from "react";
import { aadaInviteHomePath, aadaRegistrationAgentRid, aadaRegistrationPath, aadaRoomGamePath, isAadaRegisteredPlayer } from "./AadaRoomInvite";

// Keep the room in the existing auth return URL, including phone/email mode changes.
export function useAadaRoomInvite({ location, history, getPersist, setPersist, getGameUrl, hallOrigin }) {
  const handled = useRef("");
  const loaded = getPersist("dataLoaded");
  const userInfo = getPersist("user_info");
  useEffect(() => {
    if (!loaded) return;
    if (location.pathname !== "/home" && location.pathname !== "/") {
      handled.current = "";
      return;
    }
    const returnPath = aadaInviteHomePath(location.search);
    if (!returnPath) {
      handled.current = "";
      return;
    }
    const registered = isAadaRegisteredPlayer(userInfo);
    const key = `${registered ? "game" : "register"}:${returnPath}`;
    if (handled.current === key) return;
    handled.current = key;
    const incoming = new URLSearchParams(returnPath.split("?")[1]);
    setPersist("agent_rid", aadaRegistrationAgentRid(returnPath, ""));
    setPersist("agent_from", incoming.get("f") || "");
    if (registered) {
      history.replace(aadaRoomGamePath(location.search, getGameUrl(3), hallOrigin));
    } else {
      setPersist("isLogin", false);
      setPersist("login_back_url", returnPath);
      history.replace(aadaRegistrationPath(returnPath));
    }
  }, [loaded, location.pathname, location.search, userInfo, getGameUrl, hallOrigin, history, setPersist]);
}
